export default "assets/images/icons/earth-c5c1a3c0.svg";